/** Recorte de RI al momento: solo filas de bono_ri_asignacion. No usar planteles_usuario. */
export function esAsignacionBonoRi(fila, usuario) {
  if (!fila || !usuario) return false
  const iderp = Number(
    usuario.iderp != null && usuario.iderp !== '' ? usuario.iderp : usuario.id_usuario
  ) || 0
  const idTrab = Number(usuario.id_trabajador) || 0
  if (iderp && Number(fila.id_usuario) === iderp) return true
  if (idTrab && Number(fila.id_trabajador) === idTrab) return true
  return false
}

export function filasBonoRiDelUsuario(filas, usuario) {
  return (filas || []).filter((fila) => esAsignacionBonoRi(fila, usuario))
}
